var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-component_scroll"},[_c('el-backtop',{attrs:{"target":".page-component_scroll"}},[_c('div',{staticClass:"box"},[_c('img',{attrs:{"src":require("../../static/backTop.png"),"alt":""}})])]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }